import { csHttp } from "./http";
import { csByPhone } from "./auth.api";
import { csSendOtp, csConfirmOtp } from "./verify.api";

// 1) telefon var/yox check (by-phone ilə)
export async function csCheckPhoneExists(phone) {
  // byPhone success olarsa -> var, error olarsa -> yoxdur
  await csByPhone(phone);
  return true;
}

// 2) OTP göndər (mövcud verify endpoint)
export const csResetSendOtp = (phone) => csSendOtp(phone);

// 3) OTP təsdiq (mövcud verify endpoint)
export const csResetConfirmOtp = (phone, otp) => csConfirmOtp(phone, otp);

// 4) Şifrəni dəyiş (BACKEND-də əlavə etməlisən)
export const csResetSetNewPassword = (phone, newPassword) =>
  csHttp.post("/api/auth/reset-password", { phone, newPassword }).then(r => r.data);

